function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { getMethodTooManyArgsErrorMsg } from './errorMessages';
export var MethodMeta = function MethodMeta(_ref) {
  var func = _ref.func,
      name = _ref.name,
      givenName = _ref.givenName;

  _classCallCheck(this, MethodMeta);

  this.property = void 0;
  this.name = void 0;
  this.hasParams = void 0;
  this.schema = void 0;
  this.property = name || func.name;

  if (func.length > 1) {
    throw Error(getMethodTooManyArgsErrorMsg(this.property));
  }

  this.name = givenName || this.property;
  this.hasParams = func.length > 0;
};
//# sourceMappingURL=MethodMeta.js.map